module.exports = __webpack_public_path__ + "img/bowen5.6cb30e30.png";